import { Injectable } from '@angular/core';
import { AbstractFilterService } from './abstract-filter.service';

@Injectable({providedIn: 'root'})
export class TaxiEarningsFilterService extends AbstractFilterService {
  constructor() {
    super();
    this.fulltextSearchFields = [];
    this.operations = {phone: 'like', ...this.operations};
  }
}
